import axios from "../../../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import HttpStatus from "../../../components/Api/HttpStatus";
import { dispatch } from "../../../components/App/App";
import setError from "../../../store/error/actions/setError";

export default (auditId: string) =>
  axios
    .post<boolean>(
      `${BackendServices.AUDIT_SERVICE.VERIFY}/notifyAuditOwnerRequestReportAccess/${auditId}`,
      
    )
    .then((response) => {
      if(response.data==true)
      {
       dispatch(
          setError(
            "Your request for report access has been sent"
          )
        );
        window.location.reload();
    }
  })
    .catch((reason: any) => {
      if (reason?.response?.status === HttpStatus.NOT_FOUND) {
        dispatch(
          setError(
            "Some error occured"
          )
        );
      }
    });
